module.exports = __webpack_public_path__ + "img/16_31.2ba96681.png";